'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Auth = function () {
  function Auth(params) {
    _classCallCheck(this, Auth);

    var _ref = params || {},
        servicesUrl = _ref.servicesUrl;

    if (params == null || !servicesUrl) {
      throw new Error('servicesUrl must be supplied.');
    }
    this.servicesUrl = servicesUrl;
  }

  /**
   * Login user with credentials.
   * @param {string} username
   * @param {string} password
   */


  _createClass(Auth, [{
    key: 'login',
    value: function login(username, password) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (!username || !password) {
          reject(new Error('Must supply username and password'));
        }
        var headers = new Headers();
        var creds = window.btoa(username + ':' + password);
        headers.set('Authorization', 'Basic ' + creds);

        fetch(_this.servicesUrl + '/auth/login', {
          credentials: 'include',
          headers: headers,
          method: 'POST'
        }).then(function (response) {
          if (response.ok) {
            response.json().then(function (obj) {
              resolve({
                identity: obj
              });
            }, function () {
              reject(new Error('Error parsing identity'));
            });
          } else {
            reject(new Error('Login failed'));
          }
        }, function () {
          reject(new Error('Login request failed'));
        });
      });
    }

    /**
     * Logout current user.
     */

  }, {
    key: 'logout',
    value: function logout() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        fetch(_this2.servicesUrl + '/auth/logout', {
          credentials: 'include',
          method: 'POST'
        }).then(function () {
          resolve();
        }, function () {
          reject(new Error('Logout failed'));
        });
      });
    }

    /**
     * Retrieves identity for the current session. Can be used
     *  to check whether a current session exists or is valid.
     */

  }, {
    key: 'identify',
    value: function identify() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        fetch(_this3.servicesUrl + '/auth/info', {
          credentials: 'include'
        }).then(function (response) {
          if (response.ok) {
            response.json().then(function (obj) {
              resolve({
                identity: obj
              });
            }, function () {
              reject(new Error('Error parsing identity'));
            });
          } else {
            reject(new Error('Identify rejected'));
          }
        }, function () {
          reject(new Error('Identify request failed'));
        });
      });
    }
  }]);

  return Auth;
}();

exports.default = Auth;